import { injectIntl } from 'react-intl';

const ModalFooter = ({ intl }) => {
  if (intl.locale === 'en') {
    return (
      <>
        <div className="text-weight-semi-bold mb-3">
          Setting cookies in the browser
        </div>
        <div className="mb-3">
          You can disable them by changing your browser settings.
        </div>
        <div className="mb-base">
          <a
            href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&amp;hl=pt-BR"
            target="_blank"
            rel="noreferrer"
          >
            Chrome
          </a>
        </div>
        <div className="mb-base">
          <a
            href="https://support.mozilla.org/pt-BR/kb/desative-cookies-terceiros-impedir-rastreamento"
            target="_blank"
            rel="noreferrer"
          >
            Firefox
          </a>
        </div>
        <div className="mb-base">
          <a
            href="https://support.microsoft.com/en-us/help/4027947/microsoft-edge-delete-cookies"
            target=" _blank"
          >
            Microsoft Edge
          </a>
        </div>
        <div className="mb-base">
          <a
            href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage -cookies"
            target="_blank"
            rel="noreferrer"
          >
            Internet Explorer
          </a>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="text-weight-semi-bold mb-3">
        Configuração de cookies no navegador
      </div>
      <div className="mb-3">
        Você pode desabilitá-los alterando as configurações do seu navegador.
      </div>
      <div className="mb-base">
        <a
          href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&amp;hl=pt-BR"
          target="_blank"
          rel="noreferrer"
        >
          Chrome
        </a>
      </div>
      <div className="mb-base">
        <a
          href="https://support.mozilla.org/pt-BR/kb/desative-cookies-terceiros-impedir-rastreamento"
          target="_blank"
          rel="noreferrer"
        >
          Firefox
        </a>
      </div>
      <div className="mb-base">
        <a
          href="https://support.microsoft.com/en-us/help/4027947/microsoft-edge-delete-cookies"
          target=" _blank"
        >
          Microsoft Edge
        </a>
      </div>
      <div className="mb-base">
        <a
          href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage -cookies"
          target="_blank"
          rel="noreferrer"
        >
          Internet Explorer
        </a>
      </div>
      <div></div>
    </>
  );
};

export default injectIntl(ModalFooter);
